export { default } from './QrAboutView';



// WEBPACK FOOTER //
// ./src/components/views/QrAboutView/index.js